import { NgModule } from '@angular/core';

import { RulesSearchFormComponent } from "libraries/component/sectors-air-details-list/components/rules-search-form/rules-search-form.component";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { FormFieldModule } from "libraries/module/formbuilder/fields/form-field/form-field.module";
import { DateModule } from "libraries/module/formbuilder/fields/date/date.module";
import { LocaleModule } from "libraries/service/locale/locale.module";
import { MultiselectModule } from "libraries/module/formbuilder/fields/multiselect/multiselect.module";
import { BtnModule } from "libraries/ui_button/btn.module";
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";
import { AirTicketResourceModule } from "libraries/service/resources/air-ticket-resource/air-ticket-resource.module";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormFieldModule,
        DateModule,
        LocaleModule,
        MultiselectModule,
        BtnModule,
        ConfigurationResourceModule,
        AirTicketResourceModule,
    ],
    exports: [
        RulesSearchFormComponent
    ],
    declarations: [
        RulesSearchFormComponent
    ],
    providers: [],
})
export class RulesSearchFormModule {
}
